/* BLOM — shared interactions (progressive enhancement) */
(function () {
  function icons() { if (window.lucide) window.lucide.createIcons(); }

  // Scroll reveal
  function reveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // Mobile menu drawer
  function menu() {
    var toggle = document.querySelector('.menu-toggle');
    var drawer = document.getElementById('mobile-drawer');
    if (!toggle || !drawer) return;
    function open() { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  // NOTE: the legacy localStorage demo cart() was removed — the real cart engine
  // lives in snippets/blom-cart-drawer.liquid (intercepts .buybox / .fg-add / .bx-buy
  // form submits -> /cart/add.js, syncs .cart-count from the real cart). Re-adding a
  // localStorage paint() here corrupts the real server-rendered cart badge on load.

  // Dropdowns (filter + sort), steppers, accordion
  function dropdowns() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.fbtn');
      var open = document.querySelectorAll('.fdrop.open');
      if (btn) {
        var drop = btn.closest('.fdrop');
        var wasOpen = drop.classList.contains('open');
        open.forEach(function (d) { if (d !== drop) d.classList.remove('open'); });
        drop.classList.toggle('open', !wasOpen);
        e.stopPropagation();
        return;
      }
      if (!e.target.closest('.fmenu')) open.forEach(function (d) { d.classList.remove('open'); });
    });
  }
  function steppers() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.stepper button');
      if (!b) return;
      e.preventDefault();
      var s = b.closest('.stepper');
      var v = s.querySelector('.qv');
      if (!v) return;
      if (v.tagName === 'INPUT') {
        var ni = parseInt(v.value, 10) || 0;
        ni += b.getAttribute('data-step') === 'down' ? -1 : 1;
        if (ni < 0) ni = 0;
        v.value = ni;
        v.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var n = parseInt(v.textContent, 10) || 1;
      n += b.getAttribute('data-step') === 'down' ? -1 : 1;
      if (n < 1) n = 1;
      v.textContent = n;
    });
  }
  function accordion() {
    document.querySelectorAll('.acc-head').forEach(function (h) {
      h.addEventListener('click', function () {
        var item = h.closest('.acc-item');
        var body = item.querySelector('.acc-body');
        var isOpen = item.classList.toggle('open');
        body.style.maxHeight = isOpen ? (body.scrollHeight + 'px') : '0px';
      });
    });
  }

  // Bloeimaand pill row (mobile): when you tap a month whose next chip is clipped at
  // the right edge, nudge-scroll so the next month peeks in — signals there are more
  // months to scroll (people thought only the few visible ones existed).
  function monthNudge() {
    document.addEventListener('click', function (e) {
      var mc = e.target.closest('.mchip');
      if (!mc) return;
      var mf = mc.closest('.month-filter') || document.getElementById('month-filter');
      if (!mf) return;
      var ref = mc.nextElementSibling || mc;
      var cr = mf.getBoundingClientRect(), rr = ref.getBoundingClientRect();
      if (rr.right > cr.right - 4) {
        mf.scrollBy({ left: (rr.right - cr.right) + 48, behavior: 'smooth' });
      }
    });
  }

  // Filter side-drawer (shop)
  function filterDrawer() {
    var d = document.getElementById('filter-drawer');
    if (!d) return;
    function open() { d.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { d.classList.remove('open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-filter-open]').forEach(function (b) { b.addEventListener('click', open); });
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-fd-close]')) close();
      if (e.target.closest('[data-fd-clear]')) d.querySelectorAll('input[type=checkbox]').forEach(function (c) { c.checked = false; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function init() { icons(); reveal(); menu(); dropdowns(); steppers(); accordion(); monthNudge(); filterDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', icons);
})();

/* A11y (20 aug 2026, InSpace fase 4):
   1. Horizontale rails zijn scrollbare regio's zonder toetsenbordtoegang -> tabindex/role/label.
      Label = de dichtstbijzijnde sectiekop (dus automatisch in de juiste taal), anders het genus-/lijstlabel.
   2. Gesloten overlays (aria-hidden="true") bevatten focusbare elementen -> spiegel `inert`,
      zodat Tab er niet in kan zolang ze dicht zijn. Volgt aria-hidden automatisch via MutationObserver. */
(function () {
  var RAILS = '.prow-scroll,.circle-row,.uc-row,.pgal-track,.month-filter,.reviewrow,.coll-circles,.igfeed-row,.bx-revs,.bx-angles,.gspec-row,.story-track,.life-row,.catnav-row,.pcal-scroll,.cd-upsell-row,.fb-facets,.subnav';
  function railLabel(el) {
    var sec = el.closest('section') || el.parentElement;
    var h = sec && sec.querySelector('h1,h2,h3,h4');
    var txt = h && h.textContent.replace(/\s+/g, ' ').trim();
    return (txt && txt.length > 2 && txt.length < 80) ? txt : 'Carousel';
  }
  function decorateRails() {
    document.querySelectorAll(RAILS).forEach(function (el) {
      if (el.hasAttribute('tabindex')) return;
      el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'region');
      if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', railLabel(el));
    });
  }
  function hasFocusable(el) { return !!el.querySelector('a[href], button, input, select, textarea, [tabindex]'); }
  function syncInert() {
    document.querySelectorAll('[aria-hidden]').forEach(function (el) {
      var hidden = el.getAttribute('aria-hidden') === 'true';
      if (hidden && !hasFocusable(el)) return; // decoratieve iconen ongemoeid laten
      try { el.toggleAttribute('inert', hidden); } catch (e) {}
    });
  }
  function initA11y() {
    decorateRails();
    syncInert();
    if ('MutationObserver' in window) {
      new MutationObserver(function () { syncInert(); }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initA11y);
  else initA11y();
})();
